<template>
  <p style="margin: auto">
    {{ formatedDate }}
    <v-tooltip right v-if="by">
      <template #activator="{ on }">
        <v-icon
          v-on="on"
          color="primary"
          small
          class='mr-2'
          v-html="'mdi-account-question'"
        />
      </template>
      <span v-text="by" />
    </v-tooltip>
  </p>
</template>
<script>

export default {
  name: 'LastModify',

  props: {
    date: String,
    by: String
  },

  computed: {
    formatedDate () {
      return this.date
        ? new Date(this.date).toLocaleString('pt')
        : ''
    }
  }
}
</script>
